import {User} from '../../../shared/models';
import { CategoryAssociationModel } from '../../../shared/models/category-association.model';
import {ApiService} from '../../../shared/services';
import { CategoryAssociationsService } from '../../../shared/services/category-associations.service';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

export class CategoryAssociationListResolver implements Resolve<CategoryAssociationModel[]> {

  constructor( @Inject(CategoryAssociationsService) private service: CategoryAssociationsService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CategoryAssociationModel[]> {
    return this.service.list();
  }
}
